<script setup>
const DEFAULT_ICON_URL = "/images/site/default-photo.svg";
const TEAM_ICON_URL = "/images/site/logo-lenta.svg";
const _props = defineProps({
	firstTeam: {
		type: Object,
		required: true,
	},
	secondTeam: {
		type: Object,
		required: true,
	},
	showCity: {
		type: Boolean,
		default: true,
	},
});
</script>

<template>
	<div class="i-teams">
		<div class="i-teams__wrapper">
			<div class="i-teams__item">
				<div class="i-teams__desc">
					<div class="i-teams__name">{{ firstTeam.name }}</div>
					<div v-if="showCity" class="i-teams__city">{{ firstTeam.city }}</div>
				</div>
				<div class="i-teams__image">
					<img
						width="50"
						height="50"
						:src="TEAM_ICON_URL"
						:alt="firstTeam.name + ' - Лого'"
					/>
				</div>
			</div>

			<div class="i-teams__info"><strong class="i-teams__game">- : -</strong></div>

			<div class="i-teams__item">
				<div class="i-teams__desc">
					<div class="i-teams__name">{{ secondTeam.name }}</div>
					<div v-if="showCity" class="i-teams__city">{{ secondTeam.city }}</div>
				</div>
				<div class="i-teams__image">
					<img
						width="50"
						height="50"
						:src="secondTeam.imageUrl || DEFAULT_ICON_URL"
						:alt="secondTeam.name + ' - Лого'"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-teams.scss";
</style>
